<template>
  <DrawerPanel v-model="open" title="Alerts" :badge="alertsStore.unreadAlertsCount">
    <AlertsBody mode="full" @alert-selected="open = false" />
  </DrawerPanel>
</template>

<script setup lang="ts">
import AlertsBody from '@/components/alerts-body/AlertsBody.vue';
import DrawerPanel from '@/components/drawer-panel/DrawerPanel.vue';
import { useAlertsStore } from '@/stores';

const open = defineModel<boolean>({ default: false });

const alertsStore = useAlertsStore();
</script>
